import { api } from './api';
import {
  LocationPage,
  LocationPageAdmin,
  LocationPageInput,
  LocationRulesPreview,
  LocationSummary,
} from '../types/location';

export const locationService = {
  async listPublished(): Promise<LocationSummary[]> {
    const response = await api.get<LocationSummary[]>('/locations');
    return response.data;
  },

  async getBySlug(slug: string): Promise<LocationPage> {
    const response = await api.get<LocationPage>(`/locations/${encodeURIComponent(slug)}`);
    return response.data;
  },

  async getForProperty(propertyId: string): Promise<LocationSummary> {
    const response = await api.get<LocationSummary>(
      `/locations/for-property/${encodeURIComponent(propertyId)}`
    );
    return response.data;
  },
};

export const adminLocationService = {
  async list(): Promise<LocationPageAdmin[]> {
    const response = await api.get<LocationPageAdmin[]>('/admin/locations');
    return response.data;
  },

  async create(input: LocationPageInput): Promise<LocationPageAdmin> {
    const response = await api.post<LocationPageAdmin>('/admin/locations', input);
    return response.data;
  },

  async update(id: string, input: Partial<LocationPageInput>): Promise<LocationPageAdmin> {
    const response = await api.patch<LocationPageAdmin>(`/admin/locations/${id}`, input);
    return response.data;
  },

  async setPublished(id: string, published: boolean): Promise<LocationPageAdmin> {
    const action = published ? 'publish' : 'unpublish';
    const response = await api.post<LocationPageAdmin>(`/admin/locations/${id}/${action}`);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/admin/locations/${id}`);
  },

  async preview(rules: {
    neighborhoods: string[];
    title_terms: string[];
    city?: string | null;
  }): Promise<LocationRulesPreview> {
    const response = await api.post<LocationRulesPreview>('/admin/locations/preview', rules);
    return response.data;
  },
};
